import { render, staticRenderFns } from "./MobileFlightBasket.vue?vue&type=template&id=52ea08e6&scoped=true"
import script from "./MobileFlightBasket.vue?vue&type=script&lang=js"
export * from "./MobileFlightBasket.vue?vue&type=script&lang=js"
import style0 from "./MobileFlightBasket.vue?vue&type=style&index=0&id=52ea08e6&prod&lang=scss&scoped=true"
import style1 from "./MobileFlightBasket.vue?vue&type=style&index=1&id=52ea08e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ea08e6",
  null
  
)

export default component.exports